import { com } from '@eidu/form'
import entityApiUrl from '../entity/baseUrl'
import { requireAuthContext } from '../authorization/GlobalAuthContext'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import SemanticLinksResponse = com.eidu.sharedlib.entity.analytics.SemanticLinksResponse

const getSemanticLinks = async (): Promise<readonly SemanticLink[]> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links`, {
    headers: { Authorization: `Bearer ${authContext.accessToken}` },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return SemanticLinksResponse.fromJsonString(await response.text()).semanticLinks.asJsReadonlyArrayView()
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityTypes endpoint`)
    }
  })
}

export default getSemanticLinks
